// hooks
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

// constants
import { BaseError } from '../../helpers/BaseError';

import userKeys from 'hooks/users/_queryKeys';

import {
    EntityType,
    GrantRevokeEntityPermissionRequest,
} from 'models/entity-permission.model';
import { UserRole } from 'models/user.model';

import API from '../../services/api';

import entityPermissionMutationKeys from './_mutationKeys';

const useRevokeEntityPermission = (
    entityType: EntityType,
    entityId: string,
) => {
    const queryClient = useQueryClient();

    return useMutation<
        AxiosResponse<string>,
        BaseError,
        GrantRevokeEntityPermissionRequest
    >({
        mutationFn: (payload: GrantRevokeEntityPermissionRequest) =>
            API.revokeEntityPermssion(payload),

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: userKeys.usersWithEntityPermission(
                    entityType,
                    entityId,
                ),
            });
            queryClient.invalidateQueries({
                queryKey: ['team_members', UserRole.EDITOR],
            });
        },
        mutationKey: entityPermissionMutationKeys.revokePermission(
            entityType,
            entityId,
        ),
    });
};

export default useRevokeEntityPermission;
